import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const AutomationStepSection = ({ title, description, children }) => (
  <Box sx={{ minWidth: 0, maxWidth: "100%" }}>
    <Typography
      variant="subtitle1"
      sx={{
        fontWeight: 600,
        fontSize: { xs: 16, sm: 18 },
        color: "background.paperContrastText",
        mb: 0.5,
        overflowWrap: "anywhere",
      }}
    >
      {title}
    </Typography>
    {description && (
      <Typography
        variant="body2"
        sx={{
          color: "background.paperContrastText",
          mb: { xs: 1.5, sm: 2 },
          overflowWrap: "anywhere",
        }}
      >
        {description}
      </Typography>
    )}
    {children}
  </Box>
);

export default AutomationStepSection;
